const platformCakeWidget = () => {
  let autoplay;
  const svg = document.getElementById('new-cake');
  const slides = document.querySelectorAll('.platform-cake__slide');
  const sliderLength = slides.length;
  const nextButtons = document.querySelectorAll(
    '.js-platform-cake-widget .arrow-right'
  );
  const prevButtons = document.querySelectorAll(
    '.js-platform-cake-widget .arrow-left'
  );

  if (svg) {
    svg.classList.add('state-1');
    // eslint-disable-next-line no-unused-vars
    autoplay = setInterval(() => updateSlide(null, true), 5000);
  }

  if (nextButtons) {
    nextButtons.forEach((button) => {
      const buttonIndex = button.getAttribute('data-slide');
      button.addEventListener('click', () => {
        clearInterval(autoplay);
        updateSlide(buttonIndex, true);
      });
    });
  }

  if (prevButtons) {
    prevButtons.forEach((button) => {
      const buttonIndex = button.getAttribute('data-slide');
      button.addEventListener('click', () => {
        clearInterval(autoplay);
        updateSlide(buttonIndex, false);
      });
    });
  }
  const resetSlides = () => {
    slides.forEach((slide) => slide.classList.remove('is-active'));
    svg.setAttribute('class', '');
  };

  const currentIndex = () => {
    return [...slides].findIndex((slide) =>
      slide.classList.contains('is-active')
    );
  };

  const updateSlide = (index, toNext = true) => {
    if (!index) {
      index = currentIndex();
    }

    resetSlides();

    const nextIndex = parseInt(index) + 1;
    const nextSvgIndex = parseInt(index) + 2;
    const prevIndex = parseInt(index) - 1;

    if (toNext) {
      if (index == parseInt(sliderLength) - 1) {
        slides[0].classList.add('is-active');
        svg.classList.add('state-1');
      } else {
        slides[nextIndex].classList.add('is-active');
        svg.classList.add('state-' + nextSvgIndex);
      }
    } else {
      if (index == 0) {
        slides[parseInt(sliderLength) - 1].classList.add('is-active');
        svg.classList.add('state-' + parseInt(sliderLength));
      } else {
        slides[prevIndex].classList.add('is-active');
        svg.classList.add('state-' + index);
      }
    }
  };
};

document.addEventListener('DOMContentLoaded', () => {
  platformCakeWidget();
});
